import React from 'react';
import { Link } from 'react-router-dom';

export const weddingFaqs = [
  {
    q: 'How much does a wedding at Padua Hills Theatre cost?',
    a: (
      <>
        Our <a className="faq-link" href="https://guide.paduaweddings.com/" target="_blank" rel="noreferrer">published wedding guide</a> lists event minimums of $16,000 on weekdays, $23,000 on Fridays, $31,000 on Saturdays and holidays, and $20,000 on Sundays, excluding alcohol. These are minimum spend requirements rather than a complete wedding quote. Your final proposal reflects your date, guest count, menu, bar service, rentals, fees, tax, and event details. See our <Link className="faq-link" to="/weddings/investment">wedding investment and minimums</Link> page for more pricing information.
      </>
    ),
    schemaAnswer: 'Our published wedding guide lists event minimums of $16,000 on weekdays, $23,000 on Fridays, $31,000 on Saturdays and holidays, and $20,000 on Sundays, excluding alcohol. These are minimum spend requirements rather than a complete wedding quote. Your final proposal reflects your date, guest count, menu, bar service, rentals, fees, tax, and event details. See our wedding investment and minimums page for more pricing information.'
  },
  {
    q: 'Does Padua offer all-inclusive wedding packages?',
    a: 'Padua offers a full-service wedding experience with in-house catering and a proposal tailored to your celebration. Your proposal confirms the venue arrangements, menu, bar service, rentals, enhancements, fees, and tax that apply to your event. Ask our team for an itemized estimate so you can see exactly what is included.'
  },
  {
    q: 'Is catering included in the wedding estimate?',
    a: (
      <>
        Padua provides in-house, chef-driven wedding catering. Menu selections, dining style, and guest count are arranged with our team and reflected in your custom proposal. Explore <Link className="faq-link" to="/weddings/food-and-catering">food and catering</Link> or the guide’s <a className="faq-link" href="https://guide.paduaweddings.com/#food" target="_blank" rel="noreferrer">food section</a>.
      </>
    ),
    schemaAnswer: 'Padua provides in-house, chef-driven wedding catering. Menu selections, dining style, and guest count are arranged with our team and reflected in your custom proposal. Explore food and catering or the guide’s food section.'
  },
  {
    q: 'Can we bring our own food or an outside caterer?',
    a: 'Padua’s wedding experience is built around in-house catering. Discuss any outside-food or specialty-catering request with our team before making arrangements. Outside cakes and desserts are subject to the published cutting and service fee of $3 per person.'
  },
  {
    q: 'Can we bring our own alcohol?',
    a: (
      <>
        Outside alcohol is not allowed at Padua, including in the Bridal Suite. Our team can explain the available bar options and include your selections in the proposal. See the guide’s <a className="faq-link" href="https://guide.paduaweddings.com/#bar" target="_blank" rel="noreferrer">bar section</a>.
      </>
    ),
    schemaAnswer: 'Outside alcohol is not allowed at Padua, including in the Bridal Suite. Our team can explain the available bar options and include your selections in the proposal. See the guide’s bar section.'
  },
  {
    q: 'Can Padua host a small or micro wedding?',
    a: 'Padua can accommodate intimate gatherings, with the right layout confirmed by our team. Share your guest count and preferred date so we can discuss the spaces and applicable event minimums. A smaller guest count does not automatically reduce the minimum spend.'
  },
  {
    q: 'How many wedding guests can Padua accommodate?',
    a: 'The Historic Ballroom accommodates up to 250 guests, depending on the dining layout, dance floor, rentals, and event setup. Outdoor layouts and overall event capacity should be confirmed with our team for your celebration.'
  },
  {
    q: 'Can we book a ceremony-only wedding at Padua?',
    a: (
      <>
        Our <a className="faq-link" href="https://guide.paduaweddings.com/#policies" target="_blank" rel="noreferrer">published guide</a> includes ceremony-only options, typically offered between 9 AM and noon, with a planning range of $2,500–$3,500. Availability, setup, and final pricing must be confirmed with our team. <Link className="faq-link" to="/weddings/private-tour">Request a private tour</Link> to inquire.
      </>
    ),
    schemaAnswer: 'Our published guide includes ceremony-only options, typically offered between 9 AM and noon, with a planning range of $2,500–$3,500. Availability, setup, and final pricing must be confirmed with our team. Request a private tour to inquire.'
  },
  {
    q: 'Can we book a reception-only wedding?',
    a: (
      <>
        Reception-only celebrations are an option to discuss with our team. Share your preferred date, guest count, and dining plans so we can confirm availability, the event layout, and a custom proposal. Learn about <Link className="faq-link" to="/weddings/reception">receptions</Link> and <Link className="faq-link" to="/weddings/investment">wedding pricing</Link>.
      </>
    ),
    schemaAnswer: 'Reception-only celebrations are an option to discuss with our team. Share your preferred date, guest count, and dining plans so we can confirm availability, the event layout, and a custom proposal. Learn about receptions and wedding pricing.'
  },
  {
    q: 'Can we hold both our ceremony and reception at Padua?',
    a: (
      <>
        Yes. Padua offers outdoor ceremony spaces and an indoor Historic Ballroom for the reception, with cocktail-hour spaces that connect the day naturally. Our team can help confirm your layout and timing. Explore the <Link className="faq-link" to="/weddings/ceremony">ceremony</Link> and <Link className="faq-link" to="/weddings/reception">reception</Link> spaces.
      </>
    ),
    schemaAnswer: 'Yes. Padua offers outdoor ceremony spaces and an indoor Historic Ballroom for the reception, with cocktail-hour spaces that connect the day naturally. Our team can help confirm your layout and timing. Explore the ceremony and reception spaces.'
  },
  {
    q: 'How do we schedule a private tour or check a wedding date?',
    a: (
      <>
        Request a <Link className="faq-link" to="/weddings/private-tour">private tour</Link> through our website and share your preferred date and estimated guest count. The team can help you explore the ceremony spaces, reception options, catering, and next steps for an estimate.
      </>
    ),
    schemaAnswer: 'Request a private tour through our website and share your preferred date and estimated guest count. The team can help you explore the ceremony spaces, reception options, catering, and next steps for an estimate.'
  },
  {
    q: 'Where is Padua Hills Theatre located?',
    a: 'Padua Hills Theatre is located at 4467 Padua Ave, Claremont, CA 91711, in the scenic Claremont foothills. Couples travel from across Southern California, including Pasadena, Los Angeles County, Orange County, and the Inland Empire.'
  },
  {
    q: 'Is there a space for the wedding party to get ready?',
    a: 'Yes. The Bridal Suite is available for wedding-party preparation and pre-ceremony photos. Please discuss access, timing, and event arrangements with our team.'
  },
  {
    q: 'Can we choose our own wedding vendors?',
    a: 'Padua’s preferred vendor list is a curated starting point, not a restriction. Couples retain flexibility over vendor choices; confirm any vendor requirements and arrangements with the team for your event.'
  }
];

export const weddingFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: weddingFaqs.map(({ q, a, schemaAnswer }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: schemaAnswer || a
    }
  }))
};